/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import { Box } from '../../';
import SkeletonBox from './SkeletonBox';
import useRandomSkeletonWidth from './useRandomSkeletonWidth';
/**
 * @param {object} props
 * @param {number} [props.offset] The offset for a staggered animation.
 * @param {string | number} [props.width]
 * @param {string} [props.variant] The text variant, defined in textVariants.js.
 * @param {string} [props.className]
 */
export default function SkeletonTitle({ width, offset = 0, variant = 'default', className, }) {
    const [getWidth] = useRandomSkeletonWidth(1, { width });
    return (jsx(Box, { className: className, sx: { width, variant: `title.${variant}` } },
        jsx(SkeletonBox, { as: "p", offset: offset, width: getWidth(0), sx: {
                variant: `title.${variant}`,
                transform: 'scaleY(0.7)',
            } })));
}
//# sourceMappingURL=SkeletonTitle.js.map